let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("a905R")).then(() => parcelRequire('91ovr'));